import React from 'react';
import { Prompt, PromptFunction } from '../../../../Types';
import TabSection from './TabSection';
import TabHeadline from './TabHeadline';
import InfoButton from '../../../Utility/InfoButton';
import ConnectorItem from './ConnectorItem';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { connectorService } from '../../../../Services/connectorService';
import PaginatedView from '../../../Utility/PaginatedView';

interface ConnectorTabProps {
    prompt: Prompt;
    userPrompt: boolean;
    i18n: any;
    handlePromptFunctionCheckboxChange: any;
    PromptActions: any;
}

function ConnectorTab({ prompt, userPrompt, i18n, handlePromptFunctionCheckboxChange }: ConnectorTabProps) {
    return (
        <div className="w-full">
            <TabHeadline
                title={i18n.translate({
                    id: 'tabs.connectors.title',
                    sourceName: 'Prompt',
                })}
            />
            <InfoButton configKey="connector" />

            <TabSection
                title={i18n.translate({
                    id: 'tabs.connectors.section.connectors.title',
                    sourceName: 'Prompt',
                })}
                subline={i18n.translate({
                    id: 'tabs.connectors.section.connectors.subtitle',
                    sourceName: 'Prompt',
                })}
            >
                <PaginatedView
                    listType={PaginationListType.Connectors}
                    itemsFunction={
                        !userPrompt
                            ? connectorService.getPromptFunctionsByPage
                            : connectorService.getUserPromptFunctionsByPage
                    }
                    itemsPerPage={12}
                    renderItem={(promptFunction: PromptFunction, index: number) => (
                        <ConnectorItem
                            key={promptFunction.identifier}
                            title={promptFunction.title ?? ''}
                            image={promptFunction.image}
                            identifier={promptFunction.identifier}
                            handleChangeFunction={() => {
                                handlePromptFunctionCheckboxChange({
                                    target: {
                                        checked: !prompt.functions.includes(promptFunction.identifier),
                                        name: promptFunction.identifier,
                                    },
                                } as React.ChangeEvent<HTMLInputElement>);
                            }}
                            isActive={prompt.functions.includes(promptFunction.identifier)}
                        />
                    )}
                    listClassName="grid grid-cols-[repeat(auto-fill,minmax(theme(spacing.60),1fr))] gap-3"
                    filterClassName="mb-6"
                >
                    {({ list, filter }) => (
                        <>
                            {filter}
                            {list}
                        </>
                    )}
                </PaginatedView>
            </TabSection>
        </div>
    );
}

export default ConnectorTab;
